import React, { Component, useState } from "react";
import {
  MenuList,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Tooltip,
  ListItemButton,
  Collapse,
  List,
  IconButton,
} from "@mui/material";
import {
  Home as IconHome,
  Menu as IconMenu,
  PowerSettingsNew as IconLogout,
  Group as IconUsers,
  FolderCopy as IconProjects,
  CloudUpload as IconUpload,
  InsertChart as IconChart,
  Dashboard as IconDashboard,
  AccountBalance as IconOrg,
  CheckBoxOutlined as IconApprove,
  Settings as IconSettings,
  PermMedia as IconProjectStatus,
  Margin as IconResourcePlanning,
  PunchClock as IconTimeSheet,
  ExpandLess,
  ExpandMore,
  Dns as IconMaster,
  ContentPaste as IconReports,
  Groups as IconMeeting,
  GridView as IconCrmDashboard,
  ManageAccounts as IconCrm,
  PeopleOutline as IconLeadProfile,
  OndemandVideo as IconTraining,
  Functions as IconRoi,
  ContentCopy as IconCrmReports,
} from "@mui/icons-material";
import { withSnackbar } from "notistack";

import ConfirmDialog from "components/Custom/ConfirmDialog";

import { DEFAULTS, NOTIFY, LOCAL_STORAGE, CONFIG } from "common/config";
import { CONFIRMS, LABELS, SUCCESS, ERRORS, TITLES } from "common/lables";
import { AUTH_APIs } from "apihandlers/auth";
import { COMMON_JS } from "common/scripts";

const logoSmall = require("assets/images/logo.png");

const LeftBar = (props: any) => {
  const { page, setPage, userInfo, childRef } = props;
  const [leftBar, setLeftBar] = useState(false);
  const [logoutPopup, setLogoutPopup] = useState(false);
  const [showMasterMenu, setShowMasterMenu] = useState(false);
  const [showCrmMenu, setShowCrmMenu] = useState(false);

  const onUserLogout = () => {
    AUTH_APIs.logout({}).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.LOGOUT_SUCCESS);
        localStorage.removeItem(LOCAL_STORAGE.USER_INFO);
        localStorage.removeItem(LOCAL_STORAGE.ACCESS_TOKEN);
        setLogoutPopup(false);
        setTimeout(() => {
          window.open("/login", "_self");
        }, 500);
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.LOGOUT_FAILED);
      }
    });
  };

  const onSetLeftBar = (val: boolean) => {
    setLeftBar(val);
    if (val) {
      (document.querySelector(".content") as HTMLElement).classList.add(
        "active"
      );
    } else {
      (document.querySelector(".content") as HTMLElement).classList.remove(
        "active"
      );
      setShowMasterMenu(false);
    }
  };

  const roleId = userInfo.role.id;
  let mainMasterAccess = roleId === CONFIG.USER_ROLES.Admin;
  let tripEntryAccess =
    roleId === CONFIG.USER_ROLES.Admin ||
    roleId === CONFIG.USER_ROLES.Placement;

  let masterEntryLevel = false;
  let transactionEntryLevel = false;
  if (roleId === CONFIG.USER_ROLES.Admin) {
    masterEntryLevel = true;
    transactionEntryLevel = true;
  } else {
    masterEntryLevel = true;
    transactionEntryLevel = true;
  }

  let menuAdmin = roleId === CONFIG.USER_ROLES.Admin;

  let crmMenu = true;
  let menuCrmDashboard = true;
  let menuCrmLeadProfile = true;
  let menuRoi = true;
  let menuCrmReports = true;

  if (childRef) {
    childRef.hideCrmMenu = () => {
      setShowCrmMenu(false);
    };
  }
  console.log("showCrmMenu:", showCrmMenu);

  return (
    <div className={"leftBar " + (leftBar ? "active" : "")}>
      <MenuList className="leftMenuWrapper">
        <MenuItem className={"leftMenu"} onClick={() => onSetLeftBar(!leftBar)}>
          <ListItemIcon>
            <IconMenu fontSize="small" />
          </ListItemIcon>
          <div>
            <h4>
              {CONFIG.SITE_NAME} <small>{CONFIG.VERSION}</small>
            </h4>
            {/* <img src={logoSmall} className="responsive" /> */}
          </div>
        </MenuItem>

        <MenuItem
          className={
            "leftMenu " +
            (page === LABELS.HOME || page === LABELS.MENU || page === ""
              ? "active"
              : "")
          }
          onClick={() => setPage(LABELS.HOME)}
        >
          <Tooltip title={LABELS.HOME} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconHome fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">{LABELS.HOME}</ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        {/* <MenuItem
          className={"leftMenu " + (page === LABELS.REPORTS ? "active" : "")}
          onClick={() => setPage(LABELS.REPORTS)}
        >
          <Tooltip title={LABELS.REPORTS} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconReports fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">{LABELS.REPORTS}</ListItemText>
            </div>
          </Tooltip>
        </MenuItem> */}

        <MenuItem
          className={"leftMenu " + (page === LABELS.MASTERS ? "active" : "")}
          onClick={() => setPage(LABELS.MASTERS)}
        >
          <Tooltip title={LABELS.MASTERS} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconMaster fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">{LABELS.MASTERS}</ListItemText>
            </div>
          </Tooltip>
        </MenuItem>
        <MenuItem
          className={"leftMenu " + (page === LABELS.TRAINING ? "active" : "")}
          onClick={() => setPage(LABELS.TRAINING)}
        >
          <Tooltip title={LABELS.TRAINING} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconTraining fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.TRAINING}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        {/* {masterEntryLevel && (
          <ListItemButton
            onClick={() => {
              setShowMasterMenu(!showMasterMenu);
            }}
            style={{
              paddingLeft: 20,
            }}
          >
            <ListItemIcon
              style={{
                minWidth: 26,
                position: "relative",
                left: leftBar ? 0 : -5,
              }}
            >
              <IconMaster style={{ fontSize: 18 }} />
            </ListItemIcon>
            {leftBar && (
              <ListItemText
                className="menuText"
                primary="Masters"
                style={{
                  textAlign: "left",
                  color: "#fff",
                  marginLeft: 18,
                }}
              />
            )}
            {leftBar && (showMasterMenu ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}
        <Collapse in={showMasterMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding> */}
        {/* {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.HOLIDAY_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.HOLIDAY_MASTER)}
              >
                <Tooltip
                  title={LABELS.HOLIDAY_MASTER}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.HOLIDAY_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )} */}

        {/* {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.TASK_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.TASK_MASTER)}
              >
                <Tooltip title={LABELS.TASK_MASTER} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.TASK_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )} */}

        {/* {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.GPT_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.GPT_MASTER)}
              >
                <Tooltip title={LABELS.GPT_MASTER} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.GPT_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.PRICE ? "active" : "")
                }
                onClick={() => setPage(LABELS.PRICE)}
              >
                <Tooltip title={LABELS.PRICE} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.PRICE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )} */}

        {/* {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.SCHEME ? "active" : "")
                }
                onClick={() => setPage(LABELS.SCHEME)}
              >
                <Tooltip title={LABELS.SCHEME} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.SCHEME}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )} */}

        {/* {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " +
                  (page === LABELS.PROJECT_TYPE_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.PROJECT_TYPE_MASTER)}
              >
                <Tooltip
                  title={LABELS.PROJECT_TYPE_MASTER}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.PROJECT_TYPE_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.PROJECTS ? "active" : "")
                }
                onClick={() => setPage(LABELS.PROJECTS)}
              >
                <Tooltip title={LABELS.PROJECTS} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.PROJECTS}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " +
                  (page === LABELS.RESPONSIBILITY_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.RESPONSIBILITY_MASTER)}
              >
                <Tooltip
                  title={LABELS.RESPONSIBILITY_MASTER}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.RESPONSIBILITY_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.WORK_PACKAGES ? "active" : "")
                }
                onClick={() => setPage(LABELS.WORK_PACKAGES)}
              >
                <Tooltip title={LABELS.WORK_PACKAGES} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.WORK_PACKAGES}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " +
                  (page === LABELS.DESIGNATION_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.DESIGNATION_MASTER)}
              >
                <Tooltip
                  title={LABELS.DESIGNATION_MASTER}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.DESIGNATION_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " +
                  (page === LABELS.EMPLOYEE_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.EMPLOYEE_MASTER)}
              >
                <Tooltip
                  title={LABELS.EMPLOYEE_MASTER}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.EMPLOYEE_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {menuAdmin && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.USERS ? "active" : "")
                }
                onClick={() => setPage(LABELS.USERS)}
              >
                <Tooltip title={LABELS.USERS} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.USERS}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )} */}
        {/* </List>
        </Collapse> */}

        {crmMenu && (
          <ListItemButton
            onClick={() => {
              setShowCrmMenu(!showCrmMenu);
            }}
            className="leftDropDownMenu"
          >
            <ListItemIcon className="leftDropDownMenuIcon">
              <IconCrm />
            </ListItemIcon>
            {leftBar && (
              <ListItemText
                className="menuText leftDropDownMenuText"
                primary={LABELS.CRM}
              />
            )}
            {leftBar && (showCrmMenu ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}
        <Collapse in={showCrmMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {menuCrmDashboard && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.CRM_DASHBOARD ? "active" : "")
                }
                onClick={() => setPage(TITLES.CRM_DASHBOARD)}
              >
                <Tooltip title={TITLES.CRM_DASHBOARD} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.CRM_DASHBOARD}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {menuCrmLeadProfile && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.LEAD_PROFILE ? "active" : "")
                }
                onClick={() => setPage(TITLES.LEAD_PROFILE)}
              >
                <Tooltip title={TITLES.LEAD_PROFILE} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.LEAD_PROFILE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {menuRoi && (
              <MenuItem
                className={
                  "leftMenu subMenu " + (page === TITLES.ROI ? "active" : "")
                }
                onClick={() => setPage(TITLES.ROI)}
              >
                <Tooltip title={TITLES.ROI} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconRoi />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.ROI}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {menuCrmReports && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.CRM_REPORTS ? "active" : "")
                }
                onClick={() => setPage(TITLES.CRM_REPORTS)}
              >
                <Tooltip title={TITLES.CRM_REPORTS} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmReports fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.CRM_REPORTS}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
          </List>
        </Collapse>

        {/* {masterEntryLevel && (
          <MenuItem
            className={
              "leftMenu " + (page === LABELS.TIME_SHEET ? "active" : "")
            }
            onClick={() => setPage(LABELS.TIME_SHEET)}
          >
            <Tooltip title={LABELS.TIME_SHEET} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconTimeSheet fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.TIME_SHEET}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {masterEntryLevel && (
          <MenuItem
            className={
              "leftMenu " +
              (page === LABELS.TIME_SHEET_APPROVAL ? "active" : "")
            }
            onClick={() => setPage(LABELS.TIME_SHEET_APPROVAL)}
          >
            <Tooltip
              title={LABELS.TIME_SHEET_APPROVAL}
              placement={"right-start"}
            >
              <div>
                <ListItemIcon>
                  <IconTimeSheet fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.TIME_SHEET_APPROVAL}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {masterEntryLevel && (
          <MenuItem
            className={
              "leftMenu " + (page === LABELS.RESOURCE_PLANNING ? "active" : "")
            }
            onClick={() => setPage(LABELS.RESOURCE_PLANNING)}
          >
            <Tooltip title={LABELS.RESOURCE_PLANNING} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconResourcePlanning fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.RESOURCE_PLANNING}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {masterEntryLevel && (
          <MenuItem
            className={
              "leftMenu " + (page === LABELS.LEAVE_PLANNER ? "active" : "")
            }
            onClick={() => setPage(LABELS.LEAVE_PLANNER)}
          >
            <Tooltip title={LABELS.LEAVE_PLANNER} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconUsers fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.LEAVE_PLANNER}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {masterEntryLevel && (
          <MenuItem
            className={
              "leftMenu " + (page === LABELS.MINUTES_OF_MEETING ? "active" : "")
            }
            onClick={() => setPage(LABELS.MINUTES_OF_MEETING)}
          >
            <Tooltip
              title={LABELS.MINUTES_OF_MEETING}
              placement={"right-start"}
            >
              <div>
                <ListItemIcon>
                  <IconMeeting fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.MINUTES_OF_MEETING}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {masterEntryLevel && (
          <MenuItem
            className={
              "leftMenu " +
              (page === LABELS.LEAVE_PLANNER_APPROVE ? "active" : "")
            }
            onClick={() => setPage(LABELS.LEAVE_PLANNER_APPROVE)}
          >
            <Tooltip
              title={LABELS.LEAVE_PLANNER_APPROVE}
              placement={"right-start"}
            >
              <div>
                <ListItemIcon>
                  <IconUsers fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.LEAVE_PLANNER_APPROVE}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {masterEntryLevel && (
          <MenuItem
            className={"leftMenu " + (page === LABELS.PAY_SLIP ? "active" : "")}
            onClick={() => setPage(LABELS.PAY_SLIP)}
          >
            <Tooltip title={LABELS.PAY_SLIP} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconReports fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.PAY_SLIP}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )} */}

        {/* {masterEntryLevel && (
          <MenuItem
            className={"leftMenu " + (page === LABELS.INVOICE ? "active" : "")}
            onClick={() => setPage(LABELS.INVOICE)}
          >
            <Tooltip title={LABELS.INVOICE} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconReports fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.INVOICE}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {masterEntryLevel && (
          <MenuItem
            className={
              "leftMenu " + (page === LABELS.INVOICE_PRINT ? "active" : "")
            }
            onClick={() => setPage(LABELS.INVOICE_PRINT)}
          >
            <Tooltip title={LABELS.INVOICE_PRINT} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconReports fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.INVOICE_PRINT}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )} */}

        <MenuItem
          className={"leftMenu " + (page === LABELS.SETTINGS ? "active" : "")}
          onClick={() => setPage(LABELS.SETTINGS)}
        >
          <Tooltip title={LABELS.SETTINGS} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconSettings fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.SETTINGS}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        <MenuItem
          className={"leftMenu " + (page === LABELS.LOGOUT ? "active" : "")}
          onClick={() => setLogoutPopup(!logoutPopup)}
        >
          <Tooltip title={LABELS.LOGOUT} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconLogout fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">{LABELS.LOGOUT}</ListItemText>
            </div>
          </Tooltip>
        </MenuItem>
      </MenuList>

      <ConfirmDialog
        open={logoutPopup}
        title={LABELS.CONFIRM}
        msg={CONFIRMS.SURE_TO_LOGOUT}
        size={DEFAULTS.DIALOG_SIZE}
        onClose={() => setLogoutPopup(false)}
        onOk={onUserLogout}
      />
    </div>
  );
};

export default withSnackbar(LeftBar);
